export default __webpack_public_path__ + "static/media/Grasp of a Thousand Blossoms.3b73b941.jpg";